import api from "./https";

export default {
  get: (id = null, params) => api.get(`/sessions${id == null ? "" : `/${id}`}`, { params }),
  post: data => api.post("/sessions", data),
  put: (id, data) => api.put(`/sessions/${id}`, data),
  delete: id => api.delete(`/sessions/${id}`)
};
